import React from 'react';
import cn from 'classnames';

import IconButton from '@components/common/IconButton';
import SearchInput from '@components/common/SearchInput';

import { Icons } from '@icons/icons';

import styles from './GroupSelectMenuSearch.module.scss';

interface IGroupSelectMenuSearch {
	placeholder: string;
	searchThreshold: number;
	onSearchHandler: (value: string) => void;
	onSearchClear: () => void;
	isCheckedSort: boolean;
	onChangeSort: () => void;
	refreshOptions: () => void;
	searchValue: string;
	readOnly: boolean;
	maxSelectionText?: string;
	isMaxSelectionError?: boolean;
}

const GroupSelectMenuSearch = ({
	isCheckedSort,
	placeholder,
	searchThreshold,
	onSearchHandler,
	onSearchClear,
	onChangeSort,
	refreshOptions,
	searchValue,
	readOnly,
	maxSelectionText,
	isMaxSelectionError,
}: IGroupSelectMenuSearch) => {
	const errorClasses = cn(styles.maxSelectionText, {
		[styles.maxSelectionTextError]: isMaxSelectionError,
	});

	return (
		<div className={styles.wrapper}>
			<div className={styles.header}>
				<div
					className={errorClasses}
					data-testid='max-selection-text'
				>
					{maxSelectionText ? maxSelectionText : ''}
				</div>
				<div className={styles.sortButtons}>
					<IconButton
						icon={Icons.resetIcon}
						isDisabled={!isCheckedSort || readOnly}
						isFillPath
						isRound
						isWithoutShadow
						onClick={refreshOptions}
						tooltipLabel='Refresh'
					/>
					<IconButton
						icon={Icons.alphabeticSortIcon}
						isActive={!isCheckedSort}
						isRound
						isWithoutShadow
						onClick={onChangeSort}
						tooltipLabel={isCheckedSort ? 'Sort alphabetically' : 'Set default sorting'}
					/>
				</div>
			</div>
			<SearchInput
				isClearable
				onClear={onSearchClear}
				onSearch={onSearchHandler}
				placeholder={placeholder}
				searchThreshold={searchThreshold}
				value={searchValue}
			/>
		</div>
	);
};

export default GroupSelectMenuSearch;
